import React, { useMemo, useState } from 'react';
import { BadgeCheck } from 'lucide-react';
import { REVIEWS, REVIEW_STATS, FLAVOUR_ORDER, FLAVOURS } from '../../data/mock';
import StarRating from '../../components/StarRating';
import Reveal from '../../components/Reveal';
import { useFlavour } from '../../context/FlavourContext';

function ReviewCard({ r }) {
  const color = r.flavour === 'mix' ? '#ff2d2d' : (FLAVOURS[r.flavour]?.primary || '#ff2d2d');
  return (
    <div className="shrink-0 w-[300px] rounded-2xl border border-white/10 bg-[#0d0d0d] p-5">
      <StarRating value={r.rating} size={15} />
      <p className="text-white/80 mt-3 text-sm leading-relaxed">“{r.text}”</p>
      <div className="mt-4 flex items-center justify-between">
        <div>
          <p className="font-cond tracking-wide text-sm">{r.name}</p>
          <p className="text-xs" style={{ color }}>{r.flavour === 'mix' ? 'Mix Box' : FLAVOURS[r.flavour]?.name}</p>
        </div>
        {r.verified && <span className="flex items-center gap-1 text-[10px] text-white/40"><BadgeCheck className="w-3.5 h-3.5" style={{ color }} /> Verified</span>}
      </div>
    </div>
  );
}

export default function ReviewsStrip() {
  const { flavourId } = useFlavour();
  const [filter, setFilter] = useState('all');

  const filtered = useMemo(() => (filter === 'all' ? REVIEWS : REVIEWS.filter((r) => r.flavour === filter)), [filter]);
  const loop = [...filtered, ...filtered];

  return (
    <section className="py-20 md:py-28 bg-[#080808] overflow-hidden">
      <div className="max-w-[1400px] mx-auto px-5">
        <Reveal className="text-center mb-6">
          <h2 className="font-display text-4xl md:text-6xl">THEY FELT<br /><span className="text-flavour flavour-transition">THE DIFFERENCE.</span></h2>
          <div className="flex items-center justify-center gap-3 mt-4">
            <span className="font-display text-4xl">{REVIEW_STATS.rating}</span>
            <div><StarRating value={5} size={18} /><p className="text-xs text-white/40">{REVIEW_STATS.count.toLocaleString()} verified reviews</p></div>
          </div>
        </Reveal>

        <div className="flex items-center justify-center gap-2 flex-wrap mb-10">
          {['all', ...FLAVOUR_ORDER].map((id) => {
            const on = filter === id;
            const color = id === 'all' ? '#ff2d2d' : FLAVOURS[id].primary;
            return (
              <button key={id} onClick={() => setFilter(id)}
                className="px-4 py-2 rounded-full border font-cond tracking-wide text-sm transition-all"
                style={{ borderColor: on ? color : 'rgba(255,255,255,0.12)', background: on ? color : 'transparent', color: on ? '#000' : 'rgba(255,255,255,0.7)' }}>
                {id === 'all' ? 'ALL' : FLAVOURS[id].name}
              </button>
            );
          })}
        </div>
      </div>

      <div className="relative">
        <div className="flex gap-5 w-max marquee-track px-5" key={filter}>
          {loop.map((r, i) => (<ReviewCard key={`${r.id}-${i}`} r={r} />))}
        </div>
      </div>
    </section>
  );
}
